import { SVGProps } from 'react';

const TerminalFNeutral = ({
  props,
  size = 64,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      d="M45.333 16v32H18.667V16h26.666ZM20.61 46.203h11.276V17.798H20.609v28.405Zm9.247-26.608v1.775h-2.604v23.036h-1.94V21.37h-2.605v-1.775h7.15Zm5.912 0v24.81h1.941v-9.994h3.196v-1.775H37.71V21.37h3.74v-1.776h-5.681Z"
    />
  </svg>
);

export default TerminalFNeutral;
